/**
 * Environment detection utilities for the application
 */

/**
 * Gets the current environment name
 * Used for Sentry environment tagging and other environment-specific logic
 */
export const getEnvironment = (): string => {
  return process.env.VITE_ENVIRONMENT || process.env.NODE_ENV || 'development';
};
